import { Server } from 'lucide-react';

import { cn } from '@/lib/utils';

/** Short labels for the known providers; unknown providers render verbatim. */
const PROVIDER_LABELS: Record<string, string> = {
  hetzner: 'Hetzner',
  ionos: 'IONOS',
  vultr: 'Vultr',
  ovh: 'OVH',
  buyvm: 'BuyVM',
  hostinger: 'Hostinger',
  arsys: 'Arsys',
};

export function ProviderBadge({
  provider,
  className,
}: {
  provider: string;
  className?: string;
}): JSX.Element {
  const label = PROVIDER_LABELS[provider.toLowerCase()] ?? provider;

  return (
    <span className={cn('inline-flex items-center gap-1.5 font-mono text-xs', className)}>
      <Server className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden />
      {label}
    </span>
  );
}
